import React from "react";
import { useStoreState } from "../stores/index";
import Spacer from "./Spacer";
import SettingsDisplay from "./SettingsDisplay";

export default function Settings() {
    const state = useStoreState();

    return (
        <>
            <h1>Settings</h1>
            <Spacer y={1} />
            <p>
                {
                    JSON.stringify(state.config, null, "  ")
                }
            </p>
            <SettingsDisplay />
        </>
    )
    
}
